module.exports = {
    'utils_notify.back': 'Back',
    'utils_notify.retry': 'Back',
    'utils_notify.delete': 'Delete',
    'utils_notify.discard': 'Discard',
    'utils_notify.save': 'Save',

    'utils_notify.confirm': 'Confirm',
    "utils_notify.edit": "Edit",
    "utils_notify.success": "Ok!",
    "utils_notify.error": "Error!",
    "utils_notify.warning": "Warning!",
    "utils_notify.info": "Info!",

    'utils_notify.confirm_action': "Are you really sure {0}?",
    'utils_notify.confirm_action.detail': 'Click confirm to proced',
    'utils_notify.confirm_action_title': 'Confirm action',
    "utils_notify.confirm_delete": "Do you really want to delete '{0}' ?",
    "utils_notify.confirm_update": "Do you want to save changes to '{0}' ?",
    "utils_notify.confirm_update.no_name": "Do you want to save the changes?",
    "utils_notify.confirm_update.detail": "Unsaved changes will be lost.",
    "utils_notify.confirm_delete.detail": "Warning! This action cannot be undone.",
    "utils_notify.insert_success": "'{0}' has been successfully added.",
    "utils_notify.insert_head": '',
    "utils_notify.insert_error": "'{0}' cannot be added due to an error.",
    "utils_notify.update_success": "{0} has been successfully updated.",
    "utils_notify.update_head": "Updated!",
    "utils_notify.update_error": "'{0}' cannot be updated due to an error.",
    "utils_notify.delete_head": "Deleted!",
    "utils_notify.delete_success": "'{0}' has been successfully deleted.",
    "utils_notify.delete_error": "'{0}' cannot be deleted due to an error. Other elements in the system may depend on it.",
    "utils_notify.confirm_delete_title":'Confirm deletion',
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/languages/en.js
// module id = 436
// module chunks = 0